<template>
  <div class="text-[#333333] text-center">
    <span class="text-[#F95031]">{{ fraction.numerator }}</span>/{{ fraction.denominator }}
  </div>
</template>

<script>
export default {
  props: {
    scala: {
      type: String,
      default: '0/0',
    },
  },
  computed: {
    fraction() {
      const [numerator, denominator] = this.scala.split('/')
      return { numerator, denominator }
    },
  },
}
</script>
